module.exports = __webpack_public_path__ + "res/Roboto-Regular-webfont.eot?c25ce24b3801bb9b75a70027708fa27b";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Regular-webfont.eot
// module id = 16
// module chunks = 0